import { handleOpenChat } from "utils/analytics";

export default function WppFixed() {
  return (
    <div className="fixed right-5 bottom-5 z-50">
      <button onClick={handleOpenChat} name="Abrir chat" id="abrir-chat" className="abrir-chat">
        <img className="h-12" src="/wpp.png" alt="Maragogi ao Mar" />
      </button>
    </div>
  )
}